import 'twin.macro';
import PrismicText from '@leuven2030/framework/Prismic/PrismicText';
import find from 'lodash/find';
import { Alert } from '@material-ui/lab';

const ContentPrismicSlice = ({
  SliceComponents,
  type,
  primary: data,
  fields
}) => {
  if (type == 'rich_text') {
    return (
      <PrismicText
        tw="prose-sm print:prose-sm mx-auto max-w-full!"
        text={data.text}
      />
    );
  }
  const SliceComponent = find(SliceComponents, { type });

  if (SliceComponent) {
    return <SliceComponent {...{ data, fields }} />;
  }

  return <Alert severity="error">Could not render slice type: {type}</Alert>;
};

export default ContentPrismicSlice;
